import { Expose, Type } from "class-transformer";
import { IsArray, IsNumber, ValidateNested } from "class-validator";
import { Admin } from "../../entity";

export class GetAllAdminDTO {
  @Expose()
  @ValidateNested()
  @IsArray()
  @Type(() => Admin)
  admins!: Admin[];

  @Expose()
  @IsNumber()
  pageCount!: number;
}
